import React from 'react';
import Users from '../../containers/Users/Users';

const UsersPage = () => {
  return <Users />;
};

export default UsersPage;
